import { Box, Button, Typography } from '@mui/material';
import React, { useState } from 'react';
import Case from '../../interfaces/case';
import RoleManagement from '../../security/roleManagement';
import JWTTokenPayload from '../../interfaces/JWTTokenPayload';
import { decodedJWT, getOwnerType, getUserRole } from '../../utils/commonUtils';
import RemoveAgentAllocationModal from '../modals/removeAgentAllocationModal';

interface ReassignmentProps {
    selectedCases: Case[];
}

const GridActionsForManageAllocation: React.FC<ReassignmentProps> = ({ selectedCases }) => {

    const [removeAgentAllocation, loadRemoveAgentAllocation] = useState<boolean> (false);

	const token: JWTTokenPayload|false  = decodedJWT();

    return (
        <Box display="flex" justifyContent="flex-end" marginY="10px">
            {RoleManagement.isAgency(getOwnerType(token)) && !RoleManagement.isAgent(getUserRole(token)) && selectedCases?.length > 0 && (
                <Button size="medium" variant="outlined" color="primary" onClick={() => loadRemoveAgentAllocation(true)}>
                    <Typography variant="subtitle2">Remove Allocation</Typography>
                </Button>   
            )}
            { removeAgentAllocation && <RemoveAgentAllocationModal open={removeAgentAllocation} selectedRows={selectedCases} onClose={() => loadRemoveAgentAllocation(false) }/> }
        </Box>
    );
}

export default GridActionsForManageAllocation;